import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';
import { PspContainer } from './PspContainer';
const ContainerTemplatePsp = (props) => {
    const ref = useRef(null);
    const { scrollIntoView = false } = props;
    useEffect(() => {
        var _a;
        if (scrollIntoView && ref.current) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    });
    return (React.createElement("form", { onSubmit: e => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }, ref: ref },
        React.createElement(PspContainer, Object.assign({}, props))));
};
ContainerTemplatePsp.propTypes = {
    children: PropTypes.node.isRequired,
    t: PropTypes.func.isRequired,
    contentWidth: PropTypes.number,
    error: PropTypes.object,
    info: PropTypes.string,
    merchant: PropTypes.object,
    scrollIntoView: PropTypes.bool,
    subtitle: PropTypes.node,
    tFrontEndError: PropTypes.string,
    title: PropTypes.string,
};
export default connect(state => ({
    t: translator(state),
}))(ContainerTemplatePsp);
